import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import MultiLineChartCard from 'components/DetailWidgets/MultiLineChartCard'
import DonutCard from 'components/DetailWidgets/DonutCard'
import { TargetingSummaryCard, AudienceQualityCard } from './AudienceTab'

const STAT_ICONS = {
  locations: UIcons.UilLocationPinAlt,
  top_city: UIcons.UilLocationArrow,
  top_city_views: UIcons.UilEye,
  highest_completion_city: UIcons.UilCheckCircle,
  reward_claims_top_city: UIcons.UilGift,
  avg_cost_per_view: UIcons.UilCreditCard
}

export default withTranslation()(function LocationTab({ t, campaign }) {
  const { location } = campaign

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {
          location.stats.map((stat) => (
            <StatCard
              key={stat.key}
              icon={STAT_ICONS[stat.key]}
              label={stat.label}
              value={stat.value}
              suffix={stat.suffix}
              trend={stat.trend}
              tone={stat.tone}
            />
          ))
        }
      </div>

      <MultiLineChartCard title={t('rewardAds.detail.location.view_by_location_over_time')} series={location.viewByLocationOverTime.series} />

      <div className="grid md:grid-cols-2 gap-4">
        <DonutCard title={t('rewardAds.detail.location.viewers_by_location')} data={location.viewersByLocation} />
        <TargetingSummaryCard t={t} title={t('rewardAds.detail.location.targeting_summary')} summary={location.targetingSummary} />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <DonutCard title={t('rewardAds.detail.location.viewer_type_breakdown')} data={location.viewerTypeBreakdown} />
        <AudienceQualityCard title={t('rewardAds.detail.location.audience_quality')} items={location.audienceQuality} />
      </div>
    </div>
  )
})
